import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//ele引入
import ElementUI from "element-ui";
//ele样式
import "element-ui/lib/theme-chalk/index.css";
//引入弹性盒子布局样式
import "./assets/css/flex.css";
//引入公共样式
import "./utils/css/common.css";

Vue.use(ElementUI);

Vue.config.productionTip = false;
//引入Fragment解决菜单收缩时，文字不能隐藏问题
import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin);

//引入axios
import axios from "axios";
Vue.prototype.$axios = axios;

//引入echarts
//引入基本模板
let echarts = require("echarts/lib/echarts");

// 引入折线图等组件
require("echarts/lib/chart/line");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/radar");
// 引入提示框和title组件，图例
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/lib/component/grid");
require("echarts/lib/component/dataZoom");
require("echarts/lib/component/graphic");
Vue.prototype.$echarts = echarts;

//按钮权限判断
import permissions from "./permissions/index";
//挂载到vue.js上
Vue.prototype.hasPerm = permissions;

//表格获取行ID
import {
  getSelectId,
  resetForm,
  judgeEmpty,
  judgeEmptyZ,
  nowDate,
  toFixed2,
  myThrottle,
} from "./utils/js/common";
Vue.prototype.$getIds = getSelectId;
Vue.prototype.$resetForm = resetForm;
Vue.prototype.$judgeEmpty = judgeEmpty;
Vue.prototype.$judgeEmptyZ = judgeEmptyZ;
Vue.prototype.$nowDate = nowDate;
Vue.prototype.$toFixed2 = toFixed2;
Vue.prototype.$myThrottle = myThrottle;

//表单验证
import { regular } from "./utils/js/FormCheck";
Vue.prototype.$formRules = regular;

//axios请求拦截器，发送请求之前操作
axios.interceptors.request.use((config) => {
  if (config.url.indexOf("/api/sys/login") != -1) {
    //以multipart/form-data形式提交
    config.headers["Content-Type"] = "application/json";
  } else {
    //以json形式提交
    config.headers["Content-Type"] = "application/json";
  }
  if (status === 403) {
    window.location.href = "/login";
  }
  // 为请求头添加token字段
  //config.headers.token = sessionStorage.getItem('token')
  return config;
});
// http响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    //否则的话抛出错误
    if (response.status === 200) {
      // Vue.prototype.$message({
      //   showClose: true,
      //   message: "响应成功",
      //   type: "success",
      // })
      return response;
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response.status) {
      console.log("后台错误码统一处理");
      switch (error.response.status) {
        // 401:无权限
        // case 401:
        //   router.replace({
        //     path: "/login",
        //   })
        //   break
        // 403:token过期，跳转登录页面
        case 403:
          Vue.prototype.$message({
            showClose: true,
            message: "登录过期，请重新登录",
            duration: 1000,
            type: "warning",
          });
          sessionStorage.clear();
          //跳转登录页面
          setTimeout(() => {
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
          break;
        //404请求不存在
        case 404:
          Vue.prototype.$message({
            showClose: true,
            message: "未查询到数据",
            duration: 1000,
            type: "error",
          });
          break;
        case 500:
          Vue.prototype.$message({
            showClose: true,
            message: "系统错误",
            duration: 1000,
            type: "error",
          });
          break;
        //其他错误,直接抛出错误提示，接口message参数命名不一致，暂时写死
        default:
          // Vue.prototype.$message({
          //   showClose: true,
          //   message: "未知异常，请联系管理员",
          //   duration: 1000,
          //   type: "error",
          // })
          return error.response;
      }
    }
    return Promise.reject(error);
  }
);
//进入路由之前执行
router.beforeEach((to, from, next) => {
  //to  将要进入的路由
  //from  将要离开的路由
  //next  让路由继续执行

  //解决刷新之后菜单数据不存在问题
  let menuData = sessionStorage.getItem("menuList");
  if (to.path === "/login") {
    if (menuData) {
      next({ path: "/home" });
    } else {
      next();
    }
  } else {
    if (!menuData && to.name !== "login") {
      next({ path: "/login" });
    } else {
      if (store.state.MenuStore.menu_data.length == 0) {
        store.commit("getMenuList", router);
        next({ path: to.path });
      } else {
        next();
      }
    }
  }
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
